import React, { useState } from 'react';
import { RECIPE_INGREDIENT_TYPE_CEREAL_MIX, RECIPE_INGREDIENT_TYPE_PRODUCT } from '../../constant';
import { useTranslation } from 'react-i18next';
import RadioLabel from '../RadioLabel';

const IngredientTypeSwitcher = ({ changeIngredientType }) => {
    const { i18n } = useTranslation();
    const [currentIngredientType, setCurrentIngredientType] = useState(RECIPE_INGREDIENT_TYPE_PRODUCT);

    const selectIngredientType = (value) => {
        setCurrentIngredientType(value && currentIngredientType === RECIPE_INGREDIENT_TYPE_PRODUCT ? RECIPE_INGREDIENT_TYPE_CEREAL_MIX : RECIPE_INGREDIENT_TYPE_PRODUCT);
        changeIngredientType(value && currentIngredientType === RECIPE_INGREDIENT_TYPE_PRODUCT ? RECIPE_INGREDIENT_TYPE_CEREAL_MIX : RECIPE_INGREDIENT_TYPE_PRODUCT);
    };

    return (
        <label className="block__text product__form-label product__form-item" key={currentIngredientType}>
            <span className="product__form-label_text">{i18n.t('app.page.recipe.modal.addIngredient.selectType')}</span>
            <RadioLabel 
                value={currentIngredientType === RECIPE_INGREDIENT_TYPE_PRODUCT} 
                type={RECIPE_INGREDIENT_TYPE_PRODUCT}
                title={i18n.t('preference.scheme.preferenceType.product')}
                changeValue={selectIngredientType}
            />
            <RadioLabel
                value={currentIngredientType === RECIPE_INGREDIENT_TYPE_CEREAL_MIX} 
                type={RECIPE_INGREDIENT_TYPE_CEREAL_MIX}
                title={i18n.t('preference.scheme.preferenceType.cereal-mix')}
                changeValue={selectIngredientType}
            />
        </label>
    );
};

export default IngredientTypeSwitcher;
